import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { AccountRoutingModule } from './account-routing.module';

import { LoginComponent } from 'src/app/components/login/login.component';

import { LoginService } from 'src/app/services/login.service';
import { UserManagementService } from 'src/app/services/user-management.service';
import { NgbAlert } from '@ng-bootstrap/ng-bootstrap';
import { ForgotPasswordComponent } from 'src/app/components/forgot-password/forgot-password.component';
import { NgOtpInputModule } from 'ng-otp-input';
import { ResetPasswordComponent } from 'src/app/components/reset-password/reset-password.component';
import { SharedModule } from '../shared/shared.module';


@NgModule({
  declarations: [
    LoginComponent,
    ForgotPasswordComponent,
    ResetPasswordComponent
  ],
  imports: [
    CommonModule,
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
    AccountRoutingModule,
    NgbAlert,
    NgOtpInputModule,
    SharedModule
  ],
  // exports: [ LoginComponent ],
  providers: [LoginService, UserManagementService]
})
export class AccountModule { }
